/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { WorkEquipmentLayoutFilter } from './WorkEquipmentLayoutFilter';

export type WorkEquipmentLayoutRequest = {
    filter?: WorkEquipmentLayoutFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: WorkEquipmentLayoutRequest.exposeType;
}

export namespace WorkEquipmentLayoutRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
